module.exports = __webpack_public_path__ + "static/media/digital-signature.ba4e5411.svg";